import {
  ApiResponse,
  TokenData,
  VisibilityGroup,
  CreateVisibilityGroupFormData,
  Customer,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class VisibilityGroupService extends ApiService {
  public async loadVisibilityGroup() {
    const url = `${this.apiDomain}/api/visibility-group`;

    const resposne = await http.get<ApiResponse<VisibilityGroup[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateVisibilityGroup(
    data: CreateVisibilityGroupFormData,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/visibility-group/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async createVisibilityGroup(data: CreateVisibilityGroupFormData) {
    const url = `${this.apiDomain}/api/visibility-group`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async deleteVisibilityGroup(id?: string) {
    const url = `${this.apiDomain}/api/visibility-group/${id}`;

    const response = await http.remove<ApiResponse<VisibilityGroup>>(
      url,
      this.store
    );
    return response.data;
  }

  public async getVsibilityGroupUsers(id?: string) {
    const url = `${this.apiDomain}/api/visibility-group/${id}/users`;

    const resposne = await http.get<ApiResponse<Customer[]>>(url, this.store);
    return resposne?.data?.data;
  }
}
